/**
 * Webflow Marketplace compliance gate for every arbitrary-URL-training
 * surface in the portal: the Knowledge Base "Website Links" source (nav leaf,
 * route, tabs), the website-URL field + hosting question when creating an
 * agent (AddBotModal, StepStart), and the website-pages section of the
 * agent-creation Knowledge step.
 *
 * KILL SWITCH — flip URL_GATE_DISABLED and rebuild:
 *   true  → the gate is OFF: every account and agent sees the website-links
 *           surfaces again, regardless of any Webflow signal. The signals
 *           themselves (users.webflow_token via webflow_connected, and
 *           bots.webflow_hosted from Webflow-connected accounts) keep being
 *           persisted untouched, so switching back restores the old
 *           behaviour without a backfill.
 *   false → the gate is ON: any Webflow signal hides the URL-training
 *           surfaces (the pre-2026-08-26 behaviour, required for a Webflow
 *           Marketplace submission).
 *
 * ON 30.10.2026 for the Webflow Marketplace review (account-wide, as Webflow
 * credited in #1173952). OFF again since 04.11.2026 (Robert: the Webflow app is
 * live, Webflow customers get website links again). The backend switch goes
 * with it: WEBFLOW_URL_GATE_DISABLED=1 in production.
 */
export const URL_GATE_DISABLED = true;

// Whether agent creation asks accounts WITHOUT a Webflow connection where
// their site is hosted (the pre-2026-08-26 hosting question). Off (Robert,
// 30.10.2026): the gate covers Webflow-connected accounts and Webflow-hosted
// agents; everyone else creates agents exactly as before. Webflow accounts
// never see the question either way (they get the Webflow note).
export const ASK_HOSTING_QUESTION = false;

// True when the URL-training surfaces must be hidden for the given Webflow
// signals (account token, bot payload flags, ...); always false while the
// gate is disabled.
export function isUrlTrainingHidden(...signals) {
  if (URL_GATE_DISABLED) return false;
  return signals.some(Boolean);
}
